(function () {
  // Klaviyo (same company + list as the current live site)
  var KLAVIYO_COMPANY_ID = "RjTbBm";
  var KLAVIYO_LIST_ID = "SsswgT";
  var KLAVIYO_HEADERS = { 'Content-Type': 'application/json', 'revision': '2024-10-15' };

  // Adds the email to the list. Resolves on success, rejects otherwise.
  function subscribe(email, source) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: KLAVIYO_HEADERS,
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source || 'Website',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
        }
      })
    }).then(function (res) { if (res.status !== 202) throw new Error(res.status); });
  }

  // Standard email signup forms
  document.querySelectorAll('.signup').forEach(function (form) {
    var input = form.querySelector('input[type=email]');
    var btn = form.querySelector('button[type=submit]');
    var note = form.querySelector('.signup-note');
    var row = form.querySelector('.signup-row');
    var success = form.querySelector('.signup-success');
    var label = btn.textContent;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!email || !input.checkValidity()) { note.textContent = 'Enter a valid email address.'; input.focus(); return; }
      btn.disabled = true; btn.textContent = 'Joining...';
      subscribe(email, form.dataset.source).then(function () {
        row.style.display = 'none'; note.style.display = 'none';
        success.hidden = false;
        try { localStorage.setItem('td-dayone', '1'); } catch (err) {}
      }).catch(function () {
        btn.disabled = false; btn.textContent = label;
        note.textContent = 'Something went wrong. Try again.';
      });
    });
  });

  // Signup links: scroll so the form sits in the middle of the screen (not under the sticky header)
  var join = document.getElementById('join');
  if (join) {
    var centerOnJoin = function (smooth) {
      var r = join.getBoundingClientRect();
      var top = window.scrollY + r.top - Math.max(0, (window.innerHeight - r.height) / 2);
      window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
      var input = join.querySelector('input[type=email]');
      // Focus the email field on desktop; on phones this would pop the keyboard open.
      if (input && !('ontouchstart' in window)) setTimeout(function () { input.focus({ preventScroll: true }); }, smooth ? 600 : 0);
    };
    document.querySelectorAll('a[href$="#join"]').forEach(function (a) {
      if (new URL(a.href, location.href).pathname !== location.pathname) return;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        centerOnJoin(true);
      });
    });
    // Arriving from another page's signup link: center once fonts and the intro animation have settled.
    if (location.hash === '#join') window.addEventListener('load', function () {
      var settle = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
      settle.then(function () { setTimeout(function () { centerOnJoin(true); }, 400); });
    });
  }

  // Day One popup
  var popup = (function () {
    var KEY_DONE = 'td-dayone', KEY_SNOOZE = 'td-dayone-snooze';
    var read = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
    var save = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
    var el = document.createElement('div');
    el.className = 'dp';
    el.hidden = true;
    el.innerHTML =
      '<div class="dp-card" role="dialog" aria-modal="true" aria-labelledby="dp-title" tabindex="-1">' +
        '<button type="button" class="dp-x" aria-label="Close">&times;</button>' +
        '<h2 id="dp-title">Reserve $10 off<br>and early access</h2>' +
        '<p class="dp-copy">Join the Day One list.</p>' +
        '<form class="signup" novalidate>' +
          '<div class="signup-row">' +
            '<label class="sr-only" for="dp-email">Email address</label>' +
            '<input id="dp-email" type="email" required placeholder="Your email" autocomplete="email">' +
            '<button type="submit" class="btn btn-gold">Join Day One</button>' +
          '</div>' +
          '<p class="signup-note" aria-live="polite"></p>' +
          '<div class="signup-success" role="status" hidden><strong>You\'re on the Day One list</strong><span>Your $10 code arrives the day we launch, and early access invites go to the list first.</span></div>' +
        '</form>' +
      '</div>';
    document.body.appendChild(el);
    var card = el.querySelector('.dp-card'), form = el.querySelector('form');
    var input = el.querySelector('input'), note = el.querySelector('.signup-note');
    var btn = form.querySelector('.btn'), row = el.querySelector('.signup-row');
    var copy = el.querySelector('.dp-copy'), success = el.querySelector('.signup-success');
    var lastFocus = null;

    function close(snooze) {
      el.hidden = true;
      document.documentElement.classList.remove('dp-lock');
      if (snooze) save(KEY_SNOOZE, String(Date.now()));
      if (lastFocus) lastFocus.focus();
    }
    function open() {
      if (!el.hidden) return;
      lastFocus = document.activeElement;
      el.hidden = false;
      document.documentElement.classList.add('dp-lock');
      // On phones, focusing the field would pop the keyboard open.
      ('ontouchstart' in window ? card : input).focus({ preventScroll: true });
    }
    el.querySelector('.dp-x').addEventListener('click', function () { close(true); });
    el.addEventListener('mousedown', function (e) { if (e.target === el) close(true); });
    document.addEventListener('keydown', function (e) {
      if (el.hidden) return;
      if (e.key === 'Escape') close(true);
      if (e.key === 'Tab') {
        var items = [].filter.call(card.querySelectorAll('button,input'), function (n) { return n.offsetParent; });
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!email || !input.checkValidity()) { note.textContent = 'Enter a valid email address.'; input.focus(); return; }
      btn.disabled = true; btn.textContent = 'Joining...';
      subscribe(email, 'Popup').then(function () {
        save(KEY_DONE, '1');
        row.style.display = 'none'; note.style.display = 'none'; copy.style.display = 'none';
        success.hidden = false;
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Join Day One';
        note.textContent = 'Something went wrong. Try again.';
      });
    });

    // Shows itself once: after a short read or some scrolling. Not on the help pages.
    var blocked = function () { return read(KEY_DONE) || Date.now() - Number(read(KEY_SNOOZE) || 0) < 7 * 864e5; };
    if (!blocked() && !/contact|accessibility/.test(location.pathname)) {
      var fired = false;
      var auto = function () {
        if (fired) return;
        var a = document.activeElement;
        if (a && a.tagName === 'INPUT') return;
        fired = true;
        window.removeEventListener('scroll', onScroll);
        // Skip if they already opened and closed it from a button
        if (!blocked()) open();
      };
      var onScroll = function () {
        if (window.scrollY > document.documentElement.scrollHeight * .3) auto();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      setTimeout(auto, 12000);
    }
    return { open: open };
  })();

  // Mobile menu
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.getElementById('nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open);
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { nav.classList.remove('open'); toggle.setAttribute('aria-expanded', false); });
    });
  }

  // Reveal on scroll
  var els = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  } else { els.forEach(function (el) { el.classList.add('in'); }); }

  // Hero play/pause (video + ambient motion)
  var hero = document.querySelector('.hero');
  var heroBtn = document.querySelector('.hero-toggle');
  if (hero && heroBtn) {
    var video = hero.querySelector('video');
    heroBtn.addEventListener('click', function () {
      var paused = hero.classList.toggle('paused');
      if (video) { paused ? video.pause() : video.play(); }
      heroBtn.setAttribute('aria-label', paused ? 'Play background motion' : 'Pause background motion');
      heroBtn.innerHTML = paused
        ? '<svg width="12" height="14" viewBox="0 0 12 14"><path d="M1 1l10 6-10 6z" fill="#fff"/></svg>'
        : '<svg width="12" height="14" viewBox="0 0 12 14"><path d="M2 1v12M10 1v12" stroke="#fff" stroke-width="2"/></svg>';
    });
  }

  document.querySelectorAll('[data-year]').forEach(function (y) { y.textContent = new Date().getFullYear(); });
})();